function getOrganizationNameById(organizations, organizationId) {
    let organizationName = null;

    organizations.forEach(({ id, name }) => {
        if (id === organizationId) {
            organizationName = name;
        }
    });

    return organizationName;
}

export { getOrganizationNameById };
